import { QuickFilter } from '@brighterion/br-ui';
import { TFunction } from 'i18next';

export const QF_MODIFIED: {
    id: 'modifiedFlag';
    options: {
        modified: 'modified';
        new: 'new';
    };
} = {
    id: 'modifiedFlag',
    options: {
        modified: 'modified',
        new: 'new'
    }
};
export const QF_NEW_ONLY = {
    id: 'newFlag',
    options: {
        new: 'new'
    }
};
export const QF_STATUS: {
    id: 'status';
    options: {
        active: 'active';
        inactive: 'inactive';
    };
} = {
    id: 'status',
    options: {
        active: 'active',
        inactive: 'inactive'
    }
};
export const QF_MY_REPORTS: {
    id: 'myReports';
    options: {
        myReports: 'myReports';
    };
} = {
    id: 'myReports',
    options: {
        myReports: 'myReports'
    }
};

export const QF_TENANTS: {
    id: 'tenant';
    options: {
        tenantId: 'tenant';
    };
} = {
    id: 'tenant',
    options: {
        tenantId: 'tenant'
    }
};

export type QF<T = void> =
    | typeof QF_MODIFIED.id
    | typeof QF_STATUS.id
    | typeof QF_MY_REPORTS.id
    | typeof QF_NEW_ONLY.id
    | typeof QF_TENANTS.id
    | (T extends void ? 'No type' : T);

// this will add type hinting so that the user only enables
// defaults for the right type of quick filter
export type InitialFilters<T = {}> =
    | {
          id: typeof QF_MODIFIED.id;
          activeId: (keyof typeof QF_MODIFIED.options)[];
      }
    | {
          id: typeof QF_STATUS.id;
          activeId: (keyof typeof QF_STATUS.options)[];
      }
    | {
          id: typeof QF_MY_REPORTS.id;
          activeId: (keyof typeof QF_MY_REPORTS.options)[];
      }
    | {
          id: typeof QF_TENANTS.id;
          activeId: (keyof typeof QF_TENANTS.options)[];
      }
    | {
          id: T extends void ? 'No type' : T;
          activeId: string[];
      };

export type OverrideFilter<T> = { id: QF<T>; data: QuickFilter[] };

export const getFilters = <T,>(t: TFunction, qfOverrides: OverrideFilter<T>[] = []) => {
    const filters: OverrideFilter<T>[] = [
        {
            id: QF_MODIFIED.id,
            data: [
                {
                    id: QF_MODIFIED.options.new,
                    text: t('New'),
                    options: {
                        conditional: 'eq',
                        valueToMatch: 'new',
                        fieldToMatch: QF_MODIFIED.id,
                        iconName: 'table-new'
                    }
                },
                {
                    id: QF_MODIFIED.id,
                    text: t('Modified'),
                    options: {
                        conditional: 'eq',
                        valueToMatch: 'modified',
                        fieldToMatch: QF_MODIFIED.id,
                        iconName: 'table-updated'
                    }
                }
            ]
        },
        {
            id: QF_NEW_ONLY.id,
            data: [
                {
                    id: QF_MODIFIED.options.new,
                    text: t('New'),
                    options: {
                        conditional: 'eq',
                        valueToMatch: 'new',
                        fieldToMatch: QF_MODIFIED.id,
                        iconName: 'table-new'
                    }
                }
            ]
        },
        {
            id: QF_STATUS.id,
            data: [
                {
                    id: QF_STATUS.options.active,
                    text: t('Active'),
                    options: {
                        conditional: 'eq',
                        valueToMatch: true,
                        fieldToMatch: 'parameters.active'
                    }
                },
                {
                    id: QF_STATUS.options.inactive,
                    text: t('Inactive'),
                    options: {
                        conditional: 'eq',
                        valueToMatch: false,
                        fieldToMatch: 'parameters.active'
                    }
                }
            ]
        },
        ...qfOverrides
    ];

    return filters;
};
